import { Card, Empty } from 'antd';

const EmptyPage = () => {
  return (
    <Card>
      <Empty />
    </Card>
  );
};

export default EmptyPage;
